import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../services/firebase';
import { AdminLogin } from '../pages/AdminLogin';

export const AuthGuard = ({ children }) => {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return unsubscribe;
  }, []);

  if (user === undefined) return null; // still checking auth state

  if (!user) return <AdminLogin />;

  return children;
};
